export default __webpack_public_path__ + "static/media/stripes.514cafec.png";